/**
 * @NOTICE this is a temp hack / fix to cap the number of points earned for the le_tour product type
 */
export const LOYALTY_TOUR_CAPPED_EARN_POINTS_TOTAL = 140_000

/**
 * @NOTICE this is a temp hack / fix to cap the number of status credits earned for the le_tour product type
 */
export const LOYALTY_TOUR_CAPPED_EARN_STATUS_CREDITS_TOTAL = 650

/**
 * @dev this is the price at which the points and status credits are capped
 */
export const LOYALTY_TOUR_CAPPED_EARN_POINTS_PRICE = 36_843

/**
 * @dev this is the price at which the status credits are capped
 */
export const LOYALTY_TOUR_CAPPED_EARN_STATUS_CREDITS_PRICE = 19_006

/**
 * @dev temporary campaign for earn key for Singapore triple point campaign on accommodation LPP LPC
 */
export const SINGAPORE_TRIPLE_POINT_CAMPAIGN_EARN_KEY = 'productType=accommodation&campaign=triple-point'
